module.exports = __webpack_public_path__ + "img/P2-A4.3c5df7b9.svg";